import { render, staticRenderFns } from "./PageManagerExam.vue?vue&type=template&id=7c386463&scoped=true"
import script from "./PageManagerExam.vue?vue&type=script&lang=js"
export * from "./PageManagerExam.vue?vue&type=script&lang=js"
import style0 from "./PageManagerExam.vue?vue&type=style&index=0&id=7c386463&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c386463",
  null
  
)

export default component.exports